import { SystemIcon, Tag } from '@volvo/vcdk-react';
import React from 'react';

import Engine from './Engine';
import TransomShield from './TransomShield';

import { textFormatting } from '@/utils';

type Props = {
  type: string;
};

export const knownCategories = [
  'Engine',
  'Outboard',
  'Generator',
  'Drive',
  'TransomShield',
  'MarineGearbox',
  'SteeringActuator',
  'ControlSystem',
  'TractionBattery',
  'ElectricMotor',
  'ReverseGear',
  'Component',
  'Standard',
  'Extended',
  'StandardUnlimitedHrs',
  'Emission',
] as const;

const ProductType: React.FC<Props> = ({ type }) => {
  const description = (knownCategories as ReadonlyArray<string>).includes(type)
    ? textFormatting.splitPascalCase(type)
    : type === 'Unknown'
      ? 'unknown'
      : type; // Show the actual category name if it's not in known categories

  return (
    <>
      <Tag variant="neutral-subtle" size="medium">
        <div className={'flex items-center justify-center gap-2'}>
          {{
            Engine: <Engine width={25} height={25} />,
            Outboard: <SystemIcon icon="engine-penta" size={28} />,
            Generator: <SystemIcon icon="engine-genset" size={28} />,
            Drive: <SystemIcon icon="propeller" size={25} />,
            TransomShield: <TransomShield width={25} height={25} />,
            MarineGearbox: <SystemIcon icon="speedometer-normal" size={25} />,
            SteeringActuator: <SystemIcon icon="steering-wheel" size={25} />,
            ControlSystem: <SystemIcon icon="surround" size={25} />,
            TractionBattery: <SystemIcon icon="battery" size={25} />,
            ElectricMotor: <SystemIcon icon="electric-motor" size={25} />,
            ReverseGear: <Engine width={25} height={25} />,
            Component: <Engine width={25} height={25} />,
            Standard: <SystemIcon icon="badge" size={25} />,
            Extended: <SystemIcon icon="plus-circle" size={20} />,
            StandardUnlimitedHrs: <SystemIcon icon="history" size={20} />,
            Emission: <SystemIcon icon="emissions" size={25} />,
          }[type] || null}
          {description}
        </div>
      </Tag>
    </>
  );
};

export default ProductType;
